import * as React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

/**
 * CalendarDatePicker - a calendar selector that only allows selection of dates in `availableDates`.
 * Props:
 *   - availableDates: array of ISO date strings (YYYY-MM-DD) that are selectable
 *   - selectedDate: ISO date string (YYYY-MM-DD) for current value
 *   - onChange: function(newDateStr)
 */
export default function CalendarDatePicker({ availableDates, selectedDate, onChange }) {

  // Only enable dates that are in availableDates
  const shouldDisableDate = (date) => {
    const d = date.toISOString().slice(0, 10);
    return !availableDates.includes(d);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="Select Date"
        value={selectedDate ? new Date(selectedDate + 'T00:00:00') : null}
        onChange={date => {
          if (!date) return;
          // Always extract local date only
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const iso = `${year}-${month}-${day}`;
          if (availableDates.includes(iso)) onChange(iso);
        }}
        shouldDisableDate={shouldDisableDate}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            InputProps: {
              sx: {
                color: theme => theme.palette.mode === 'dark' ? '#fff' : undefined
              }
            }
          }
        }}
        disableFuture={false}
        disablePast={false}
        views={["year", "month", "day"]}
        openTo="day"
      />
    </LocalizationProvider>
  );
}
